var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 0H3.33333C1.5 0 0 1.5 0 3.33333V26.6667C0 28.5 1.5 30 3.33333 30H26.6667C28.5 30 30 28.5 30 26.6667V3.33333C30 1.5 28.5 0 26.6667 0ZM16.6667 23.3333H8.33333C7.41667 23.3333 6.66667 22.5833 6.66667 21.6667C6.66667 20.75 7.41667 20 8.33333 20H16.6667C17.5833 20 18.3333 20.75 18.3333 21.6667C18.3333 22.5833 17.5833 23.3333 16.6667 23.3333ZM21.6667 16.6667H8.33333C7.41667 16.6667 6.66667 15.9167 6.66667 15C6.66667 14.0833 7.41667 13.3333 8.33333 13.3333H21.6667C22.5833 13.3333 23.3333 14.0833 23.3333 15C23.3333 15.9167 22.5833 16.6667 21.6667 16.6667ZM21.6667 10H8.33333C7.41667 10 6.66667 9.25 6.66667 8.33333C6.66667 7.41667 7.41667 6.66667 8.33333 6.66667H21.6667C22.5833 6.66667 23.3333 7.41667 23.3333 8.33333C23.3333 9.25 22.5833 10 21.6667 10Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructions);
export default __webpack_public_path__ + "static/media/instructions.ac2f746499c0bd43b47a62762304c4f3.svg";
export { ForwardRef as ReactComponent };